export function manualWhatsAppSupportWindow(messages, nowMs = Date.now()) {
  const inbound = (Array.isArray(messages) ? messages : [])
    .filter((message) => (
      String(message?.channel || '').toLowerCase() === 'whatsapp'
      && String(message?.direction || '').toLowerCase() === 'inbound'
    ))
    .map((message) => {
      const createdMs = new Date(message?.created_at || '').getTime();
      return Number.isFinite(createdMs) ? { message, createdMs } : null;
    })
    .filter(Boolean)
    .sort((a, b) => b.createdMs - a.createdMs)[0];

  if (!inbound) {
    return { open: false, lastInboundAt: null, expiresAt: null };
  }

  const windowMs = 24 * 60 * 60 * 1000;
  const expiresMs = inbound.createdMs + windowMs;
  return {
    open: nowMs >= inbound.createdMs && nowMs <= expiresMs,
    lastInboundAt: new Date(inbound.createdMs).toISOString(),
    expiresAt: new Date(expiresMs).toISOString(),
  };
}

export function createMessageRequestId() {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  return `msg-${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
}


export function explainWhatsAppProviderFailure(message = {}) {
  const channel = String(message?.channel || '').toLowerCase();
  const delivery = String(message?.delivery_status || '').toLowerCase();
  if (channel !== 'whatsapp' || delivery !== 'failed') return null;

  const errors = Array.isArray(message?.provider_errors) ? message.provider_errors : [];
  const first = errors.find((item) => item && typeof item === 'object') || {};
  const code = String(first.code || '').trim();
  const rawReason = String(first.details || first.message || first.title || '').trim();
  const recipient = String(message?.to_phone || '').trim();

  if (code === '131042') {
    return {
      recipient,
      code,
      accountLevel: true,
      title: 'Meta billing setup is blocking WhatsApp delivery.',
      reason: 'This WhatsApp Business Account is not billing-ready. The provider error says its billing currency is not configured. Set the account country/currency in Meta Billing & payments and confirm an active payment method, then retry.',
    };
  }

  return {
    recipient,
    code,
    accountLevel: false,
    title: 'Meta did not deliver this WhatsApp message.',
    reason: rawReason || 'Meta accepted the request but did not deliver the WhatsApp message.',
  };
}
